import { IListProjectMeasurementActionsDTO } from '@features/GenerateMeasurement/model/types';
import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

export const getListProjectMeasurementActions = async () => {
    // @ts-ignore
    const url = routable.getRoute('listProjectMeasurementActions');
    try {
        const res = await $api.get<IDataResponse<IListProjectMeasurementActionsDTO[]>>(url);

        return res.data;
    } catch (error) {
        handleAxiosFetchErrorsSwal(error);
        return error.message;
    }
};
